import React from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarIcon, FilterIcon } from 'lucide-react';

/**
 * فلتر موحّد لصفحة داشبورد الطالب — نفس التواريخ لكل المقاييس.
 */
const StudentDashboardFilters = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  onApply,
  onReset,
  loading,
  isRTL,
  seasonYear,
}) => {
  const { t } = useTranslation();

  return (
    <section className="overflow-visible rounded-[1.35rem] border-[3px] border-slate-900/10 bg-white/95 shadow-[0_8px_0_0_rgba(15,23,42,0.06)]">
      <div className="overflow-hidden rounded-t-[1.2rem] border-b border-slate-200/90 bg-gradient-to-r from-indigo-50/90 via-white to-sky-50/60 px-4 py-3 sm:px-5">
        <div className={`flex flex-wrap items-center gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border-2 border-white/80 bg-white shadow-sm">
            <FilterIcon className="h-5 w-5 text-indigo-600" strokeWidth={2.25} aria-hidden />
          </div>
          <div className="min-w-0 flex-1">
            <h2 className="text-base font-black tracking-tight text-slate-900 sm:text-lg">{t('dashboard.student.statsPeriodTitle')}</h2>
            <p className="mt-0.5 text-xs font-semibold text-slate-600 sm:text-sm">{t('dashboard.stats.dateFilterScope')}</p>
          </div>
          {seasonYear != null && (
            <span className="inline-flex shrink-0 items-center rounded-full border border-sky-200/80 bg-sky-50 px-3 py-1 text-xs font-bold text-sky-900">
              {t('dashboard.student.seasonYearBadge', { year: seasonYear })}
            </span>
          )}
        </div>
      </div>
      <div className="p-4 sm:p-5">
        <div className="flex flex-col gap-3 lg:flex-row lg:flex-wrap lg:items-end">
          <label className="flex min-w-[10rem] flex-1 flex-col gap-1">
            <span className={`flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wide text-slate-500 ${isRTL ? 'flex-row-reverse' : ''}`}>
              <CalendarIcon className="h-3.5 w-3.5 shrink-0 text-sky-500" aria-hidden />
              {t('dashboard.stats.dateFrom')}
            </span>
            <input
              type="date"
              value={dateFrom}
              onChange={(e) => onDateFromChange(e.target.value)}
              className="rounded-xl border-[2px] border-slate-200/90 bg-white px-3 py-2.5 text-sm font-semibold text-slate-900 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200/80"
            />
          </label>
          <label className="flex min-w-[10rem] flex-1 flex-col gap-1">
            <span className={`flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wide text-slate-500 ${isRTL ? 'flex-row-reverse' : ''}`}>
              <CalendarIcon className="h-3.5 w-3.5 shrink-0 text-sky-500" aria-hidden />
              {t('dashboard.stats.dateTo')}
            </span>
            <input
              type="date"
              value={dateTo}
              onChange={(e) => onDateToChange(e.target.value)}
              className="rounded-xl border-[2px] border-slate-200/90 bg-white px-3 py-2.5 text-sm font-semibold text-slate-900 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200/80"
            />
          </label>
          <div className={`flex flex-wrap gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
            <button
              type="button"
              onClick={onReset}
              disabled={loading}
              className="rounded-xl border-[2px] border-slate-200/90 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 disabled:opacity-50"
            >
              {t('dashboard.stats.resetDateRange')}
            </button>
            <button
              type="button"
              onClick={onApply}
              disabled={loading}
              className="rounded-xl border-2 border-sky-500/30 bg-gradient-to-r from-sky-500 to-violet-600 px-5 py-2.5 text-sm font-bold text-white shadow-md transition hover:opacity-95 disabled:opacity-50"
            >
              {loading ? t('common.loading') : t('dashboard.stats.applyRange')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudentDashboardFilters;
